const PaidInclusion = ({
    canBeActivatedOnMobile = false,
    isAutoBillEnabled = false,
    isEnabled = false,
    isPaymentRequired = false,
    isPaymentValid = false,
    paymentValidDuration = '',
    price = '',
} = {}) => ({
    canBeActivatedOnMobile: Boolean(canBeActivatedOnMobile),
    isAutoBillEnabled: Boolean(isAutoBillEnabled),
    isEnabled: Boolean(isEnabled),
    isPaymentRequired: Boolean(isPaymentRequired),
    isPaymentValid: Boolean(isPaymentValid),
    paymentValidDuration: String(paymentValidDuration),
    price: String(price),
});

export default PaidInclusion;
